import { Breakpoints } from '../../services/utility/media-observer.types';

export const widthMap = {
  [Breakpoints.L]: 96,
  [Breakpoints.XL]: 240,
  [Breakpoints.XXL]: 292
};
